import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.number,
  startTime: PropTypes.string,
  title: PropTypes.string,
  ppv: PropTypes.bool,
  eventCardUrl: PropTypes.string,
  eventStatus: PropTypes.string,
  hasVideo: PropTypes.bool,
  hasAudio: PropTypes.bool,
  hasPassword: PropTypes.bool,
  password: PropTypes.string,
  restricted: PropTypes.bool,
  eventTypeId: PropTypes.number
});
